var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { mergeQueryString, updateSearch } from 'bernie-core';
import { getFilteredObjectKeys } from '../../../helpers/common-helper';
import { getCheckboxKeyAndId } from '../../../components/srp/sort-filter/checkbox';
import { getUpdatedFilterQueryObject, SEE_ALL_CATEGORY } from '../../../components/srp/sort-filter/filter-helper';
var getFirstAndLastIndices = function (updatedFilterState, keys) {
  var startIndex = -1;
  var endIndex = -1;
  keys.forEach(function (key, index) {
    if (updatedFilterState[key].selected && updatedFilterState[key].enabled) {
      if (startIndex === -1) {
        startIndex = index;
      } else {
        endIndex = index;
      }
    }
  });
  return {
    startIndex: startIndex,
    endIndex: endIndex
  };
};
var updateRangeFilterState = function (filterCategoryId, filterKey, checked, activitySearchStore) {
  var updatedFilterState = activitySearchStore.sortAndFilterObject.filters;
  updatedFilterState[filterCategoryId][filterKey] = {
    selected: checked,
    enabled: true
  };
  var filterKeys = getFilteredObjectKeys(updatedFilterState[filterCategoryId]);
  var _a = getFirstAndLastIndices(updatedFilterState[filterCategoryId], filterKeys),
    startIndex = _a.startIndex,
    endIndex = _a.endIndex;
  if (startIndex !== -1 && endIndex !== -1) {
    for (var i = startIndex + 1; i < endIndex; i++) {
      updatedFilterState[filterCategoryId][filterKeys[i]].selected = true;
      updatedFilterState[filterCategoryId][filterKeys[i]].enabled = false;
    }
  } else if (startIndex !== -1) {
    for (var i = 0; i < filterKeys.length; i++) {
      if (i !== startIndex) {
        updatedFilterState[filterCategoryId][filterKeys[i]].selected = false;
        updatedFilterState[filterCategoryId][filterKeys[i]].enabled = true;
      }
    }
  }
  return updatedFilterState;
};
export function rangeCheckboxClickHandler(activitySearchStore, event, history, location, inDialog) {
  var _a = getCheckboxKeyAndId(event.target.id),
    filterKey = _a.filterKey,
    filterCategoryId = _a.filterCategoryId;
  var checked = event.target.checked;
  var updatedFilterState = updateRangeFilterState(filterCategoryId, filterKey, checked, activitySearchStore);
  if (checked && updatedFilterState[SEE_ALL_CATEGORY]) {
    updatedFilterState[SEE_ALL_CATEGORY][SEE_ALL_CATEGORY] = {
      selected: !checked,
      enabled: true
    };
  }
  activitySearchStore.sortAndFilterObject.filters = updatedFilterState;
  if (!inDialog) {
    var newQueryString = mergeQueryString(location.search, __assign({}, getUpdatedFilterQueryObject(activitySearchStore)));
    updateSearch({
      history: history,
      location: location,
      newParams: newQueryString,
      newState: {},
      replace: true
    });
  }
}